var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.3 132.3",
    style: {
      enableBackground: "new 0 0 92.3 132.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A73E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.3,36.1c0,0,0-0.1,0-0.1c-0.3-1.7-0.9-3.4-1.5-5.1c-0.7-2.1-1.6-4.1-2.6-6L87.1,25l0,0c0,0,0.1-0.1,0.1-0.1 c-0.8-1.5-1.6-2.9-2.6-4.3c0-0.1-0.1-0.1-0.1-0.1l0,0C78.8,11.9,70.2,5.4,60.2,2.2l0,0C55.8,0.8,51,0,46.1,0 C32,0,19.3,6.4,10.8,16.5C4.1,24.5,0,34.9,0,46.1c0,8.7,1.7,15.7,4.6,22c4.4,9.8,11.5,17.8,19,27.4l3.7,4.9c2,2.8,4.1,5.8,6.1,8.9 c9.4,14.5,6.8,23.1,12.8,23.1s3.4-8.7,12.8-23.2l0,0c15.4-24.1,33.3-35,33.3-63C92.4,42.7,92,39.4,91.3,36.1L91.3,36.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMapMarker);
export default __webpack_public_path__ + "static/media/blue_map_marker.9d37b5f383394df3e397a277f148d055.svg";
export { ForwardRef as ReactComponent };